import clsx from "clsx";

import { Checkbox } from "@chef/components";
import { intl } from "./RatingAndCommentContainer.Intl";

interface HaveNotCookedCheckboxProps {
  rating?: number;
  onTickedHaveNotCooked?: () => void;
}

export const HaveNotCookedCheckbox = ({
  rating,
  onTickedHaveNotCooked,
}: HaveNotCookedCheckboxProps) => {
  const haveNotMadeDish = rating === 0;

  return (
    <div className={clsx("px-2 py-4 lg:px-4", haveNotMadeDish && "bg-grey-3")}>
      <Checkbox
        className="items-center flex-shrink-0"
        checked={haveNotMadeDish}
        onChange={onTickedHaveNotCooked}
        innerClassName="text-xs truncate max-w-max my-auto"
        disabled={haveNotMadeDish}
      >
        {intl.HAVE_NOT_MADE_THE_DISH}
      </Checkbox>
    </div>
  );
};
